import { all, fork } from "redux-saga/effects";
import { watchCommonSaga } from "./common";
import { watchUserMenuSaga } from "../../containers/Sidebar/state/saga";
import { withConsignedOrderSaga } from "../../containers/ConsignedOrder/state/saga";
import { withPartnersSaga } from "../../containers/Partners/state/saga";
import { withEZDParametersSaga } from "../../containers/EZDParameters/state/saga";
import { withProductsSaga } from "../../containers/Products/state/saga";
import { withSellableProductsSaga } from "../../containers/SellableProduct/state/saga";
import { withAccountBalanceSaga } from "../../containers/AccountBalance/state/saga";
import { withMonthLocksSaga } from "../../containers/MonthLocks/state/saga";
import { withPaymentTermsSaga } from "../../containers/PaymentTerms/state/saga";
import { withIngestionMonitorSaga } from "../../containers/IngestionMonitor/state/saga";
import { withRollbackIngestionSaga } from "../../containers/RollbackIngestion/state/saga";
import { withWSPartnersSaga } from "../../containers/WSPartners/state/saga";

export default function* rootSaga() {
  yield all([
    fork(watchCommonSaga),
    fork(watchUserMenuSaga),
    fork(withConsignedOrderSaga),
    fork(withPartnersSaga),
    fork(withEZDParametersSaga),
    fork(withProductsSaga),
    fork(withSellableProductsSaga),
    fork(withAccountBalanceSaga),
    fork(withMonthLocksSaga),
    fork(withPaymentTermsSaga),
    fork(withIngestionMonitorSaga),
    fork(withRollbackIngestionSaga),
    fork(withWSPartnersSaga),
  ]);
}
